import React, { useContext, useState } from 'react';
import Layout from '../../Component/layout/main-layout';
import { useTranslation } from 'react-i18next';
import Physical from '../../Component/online-service/act-request/physical';
import Juridical from '../../Component/online-service/act-request/juridical';
import AppProcedure from '../../Component/online-service/app_procedure';
import layoutBgImg from '../../Images/layout/onlineService.jpg';
import { Post } from '../../api/services/api_helpers';
import { Context } from '../../Store/context';
import GlobalLayout from '../../Component/layout/global-layout';

const ActRequest = () => {
  const { t } = useTranslation();
  const [formType, setFormType] = useState('physical');
  const [modalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { showError } = useContext(Context);

  const [data, setData] = useState({
    requester_type: '',
    organization_name: '',
    province: '',
    district: '',
    first_name: '',
    last_name: '',
    patronimic: '',
    places: '',
    act: '',
    email: '',
    message: '',
    phone_number: '',
    attachment: null,
  })

  //   const handlePost = async (e) => {
  //     e.preventDefault();
  //     setIsLoading(true);

  //     try {
  //         const response = await Post('request/', {
  //             requester_type: data.requester_type,
  //             province: data.province,
  //             district: data.district,
  //             act: data.act,
  //             places: data.places,
  //             first_name: data.first_name,
  //             last_name: data.last_name,
  //             patronimic: data.patronimic,
  //             email: data.email,
  //             phone_number: data.phone_number,
  //             attachment: data.attachment,
  //             message: data.message,
  //             organization_name: data.organization_name,
  //         });
  //         console.log('success', response);
  //     } catch (error) {
  //         showError(error?.message);
  //     } finally {
  //         setIsLoading(false);
  //     }
  // };

  return (
    <GlobalLayout
      title={`${t('request_copies')} - ${t('supreme_court')} ${t('turkmenistan')}`}
      keywords="Судебные акты, Kazyýet namalarynyň nusgalary, Kazyyet namalarynyn nusgalary"
    >
      <div className="mb-20">
        <Layout
          title={t('request_copies')}
          layoutBgImg={layoutBgImg}
        />
        <main className="px-4 xxl:px-12 xxxl:px-32 xxxxl:px-64">
          <section className="mt-8 lg:p-8 p-4 bg-white dark:bg-dark-box">
            {/* Header */}
            <div className="relative text-center">
              <h1 className="font-bold text-2xl text-primary dark:text-dark-text">
                {t('request_copies')}
              </h1>
              <button
                className="bg-primary text-white px-4 py-2 rounded 
                         lg:absolute right-0 top-0 mt-4 lg:mt-0"
                onClick={() => setModalOpen(true)}
              >
                {t('application_procedure')}
              </button>
              <AppProcedure
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
              />
            </div>

            {/* Form Type Selector */}
            <div className="my-10 flex space-x-2 justify-between lg:justify-start">
              <button
                className={`px-4 py-2 rounded-md font-semibold w-[50%] lg:w-max 
                          ${formType === 'physical' ? 'bg-primary text-white'
                    : 'bg-secondary text-black'
                  }`}
                onClick={() => setFormType('physical')}
              >
                {t('physical')}
              </button>
              <button
                className={`px-4 py-2 rounded-md font-semibold w-[50%] lg:w-max
                          ${formType === 'juridical' ? 'bg-primary text-white'
                    : 'bg-secondary text-black'
                  }`}
                onClick={() => setFormType('juridical')}
              >
                {t('juridical')}
              </button>
            </div>

            {formType === 'physical' && (
              <Physical
                data={data} setData={setData}
                // handlePost={handlePost}
                isLoading={isLoading}
              />
            )}
            {formType === 'juridical' && (
              <Juridical
                data={data} setData={setData}
                // handlePost={handlePost}
                isLoading={isLoading}
              />
            )}
          </section>
        </main>
      </div>
    </GlobalLayout>
  );
};

export default ActRequest;
